<template>
  <div v-if="messages.length > 0" class="wrapper">
    <div class="messages">
      <div
        v-for="(message, index) in messages"
        :key="index"
        class="message mb-2"
        @click="deleteMessage(message)"
      >
        <div class="mr-3">
          <img :src="getImgUrl(message.type)" style="width:30px;height:30px;" />
        </div>
        <span>{{ message.message }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
  name: 'Message',
  computed: {
    ...mapState({
      messages: state => state.message.messages,
    }),
  },
  methods: {
    ...mapMutations({
      DELETE_MESSAGE: 'message/DELETE_MESSAGE',
    }),
    getImgUrl(type) {
      if (type === 'loading') {
        return require('../assets/messages/' + type + '.gif');
      }
      return require('../assets/messages/' + type + '.png');
    },
    deleteMessage(message) {
      if (message.type !== 'loading') {
        this.DELETE_MESSAGE(message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  z-index: 100;
  @include flexCenter(column);
  pointer-events: none;
  position: fixed;
  width: 100%;
  height: 100%;
  .messages {
    .message {
      pointer-events: all;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: auto;
      padding: $space-3 $space-4;
      border-radius: $radius-md;
      font-size: $text-sm;
      font-weight: $weight-semibold;
      transition: transform $transition-fast, box-shadow $transition-fast;
      background: color(surface);
      color: color(slate-700);
      border: 1px solid color(border);
      box-shadow: $shadow-lg;

      &:hover {
        cursor: pointer;
        transform: translateY(-1px);
      }
    }
  }
}
</style>
